<div class="carousel-wrapper" *ngIf="banners.length > 0">

  <div class="carousel-header">
    <h2 class="carousel-title">Concursos activos</h2>
    <p class="carousel-subtitle">Descubre y participa para ganar increíbles premios.</p>
  </div>

  <swiper-container
    #swiperRef
    [pagination]="banners.length > 1"
    [navigation]="banners.length > 1"
    [observer]="true"
    [observeParents]="true"
    autoplay="true"
    [slidesPerView]="1"
    [spaceBetween]="10"
    class="contest-swiper">

    <swiper-slide *ngFor="let banner of banners">
      <ion-card class="contest-card">
        <div class="image-container">
          <img [src]="banner.image" [alt]="banner.contestName" class="banner-img"/>
          <div class="overlay"></div>
        </div>
      </ion-card>
    </swiper-slide>

  </swiper-container>
</div>
